// These messages are now defined in the shadow schema file

const TAG_FIELDS = new Set([
  'Subject',
  'subjects',
  'tags',
  'keywords',
  'subject',
  'Schlagwort',
]);

export const isTagField = (fieldValue) => {
  return fieldValue && TAG_FIELDS.has(fieldValue);
};

// This function is no longer needed as we handle tagWhitelist in the shadow schema
// Keeping it for backward compatibility but it's not actively used
export const tagWhitelistSchemaEnhancer = ({ schema }) => {
  return schema;
};
